import axios from 'axios';
import { isStageEnvironment } from 'utils/environment';
import { SiloManagement } from 'views/site-settings/features/inventory-silo-management/types/silo-management.type';
import { SiloData } from '../mock/silo-data.mock';

//TODO this exists in inventory-silo-management. make general api call in /shared/ and call it here?
// GET
// /ewosapi/v1/silo-management/${globalSiteId}/silos
export const getSiloManagement = async (globalSiteId: string): Promise<SiloManagement[]> => {
  if (isStageEnvironment) return SiloData;

  const res = await axios.get<SiloManagement[]>(`/ewosapi/v1/silo-management/${globalSiteId}/silos`);
  return res.data;
};
